import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-template',
  templateUrl: './preview-template.component.html',
  styleUrls: ['./preview-template.component.scss'],
})
export class PreviewTemplateComponent implements OnInit {
  @Input() previewData: any;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() { }


  get imagePreview(): SafeResourceUrl | null {
    if (!this.previewData?.image) return null;
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(this.previewData.image)
    );
  }

  get videoPreview(): SafeResourceUrl | null {
    if (!this.previewData?.video) return null;
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(this.previewData.video)
    );
  }

  get documentPreview(): SafeResourceUrl | null {
    if (!this.previewData?.document) return null;
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(this.previewData.document)
    );
  }

  get isPdf(): boolean {
    return this.previewData?.document?.type === 'application/pdf';
  }

}
